module.exports = __webpack_public_path__ + "static/p1-d1e133f98505c74643dad8c1f182207a.png";